import React, { useContext, useState, useEffect } from 'react';

import { Modal, Button, Text, Title, breakpoints } from 'components';
import {
  AuthContext,
  OnboardingPreLaunchModalContext,
  OnboardingWelcomeModalContext,
  SetupBrokerageWizardModalContext,
} from 'contexts';
import {
  CenterTextWrapper,
  Spin,
  SVGWelcome,
} from '@brokerbay/design-components';
import styled from 'styled-components';
import { GetOnboarding } from '../types/getOnboardingType';
import {
  getDisplayedPreLaunchBanner,
  shouldDisplayWizardBanner,
} from '../Router/onboarding/util';

const isSubmitter = (
  onboarding: GetOnboarding['onboarding'],
  userEmail: string,
) => onboarding?.submitters?.some(submitter => submitter.email === userEmail);

export const OnboardingWelcomeModal = () => {
  const { auth, onboarding, loadingOnboarding, orgStatus } =
    useContext(AuthContext);
  const { closeModal, visible, setIsDoneWelcomeFlow } = useContext(
    OnboardingWelcomeModalContext,
  );
  const { openModal: openSetupBrokerageWizardModal } = React.useContext(
    SetupBrokerageWizardModalContext,
  );
  const { openModal: openOnboardingPreLaunchModal } = React.useContext(
    OnboardingPreLaunchModalContext,
  );
  const [isUserSubmitter, setIsUserSubmitter] = useState(false);

  const handleClose = () => {
    closeModal();
    setIsDoneWelcomeFlow(true);
  };

  const handleClick = () => {
    closeModal();
    if (shouldDisplayWizardBanner(auth, onboarding, orgStatus)) {
      openSetupBrokerageWizardModal();
    } else if (
      getDisplayedPreLaunchBanner(auth, orgStatus) === 'showingInstructions'
    ) {
      openOnboardingPreLaunchModal();
    } else {
      setIsDoneWelcomeFlow(true);
    }
  };

  useEffect(() => {
    if (auth && onboarding) {
      setIsUserSubmitter(isSubmitter(onboarding, auth.email));
    }
  }, [auth, onboarding]);

  return (
    <Modal
      open={visible}
      onCancel={handleClose}
      cancelText="Close"
      title={<br />}
      footer={<br />}
      width={breakpoints.sm}
    >
      {loadingOnboarding ? (
        <StyledSpinnerContainer>
          <Spin />
        </StyledSpinnerContainer>
      ) : (
        <CenterTextWrapper>
          <SVGWelcome />

          <Title textAlign="center">
            Hi {auth.firstName || 'there'} 👋{' '}
            {isUserSubmitter
              ? 'Congrats on claiming your brokerage’s account!'
              : 'Welcome to BrokerBay'}
          </Title>

          {isUserSubmitter ? (
            <Text block textAlign="center" type="secondary">
              Now it&apos;s time to get your brokerage setup and ready for
              launch!
            </Text>
          ) : (
            <Text block textAlign="center" type="secondary">
              We&apos;re so glad you could make it!
            </Text>
          )}

          <br />

          <Button type="primary" onClick={handleClick}>
            Let&apos;s go!
          </Button>
        </CenterTextWrapper>
      )}
    </Modal>
  );
};

const StyledSpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 450px;
`;
